import React, { Suspense } from 'react';
import ErrorBoundary from '../../logger/ErrorBoundary';
import GlobalLoader from '../global-loader/global-loader';
import fallbackMessages from '../../Constants/strings/suspense-fallback-messages';

function SuspenseErrorBoundaryWrapper({
  fallbackMessage = fallbackMessages.DefaultMessage,
  children
}) {
  return (
    <ErrorBoundary>
      <Suspense fallback={<GlobalLoader message={fallbackMessage} />}>
        {children}
      </Suspense>
    </ErrorBoundary>
  );
}

export default SuspenseErrorBoundaryWrapper;
